<template>
  <div class="xs-topbar-wrap">
    <div class="xs-topbar" v-if="isXs">
      <button class="xs-hamburger" @click="openSidebar" :aria-label="$t('A11y.openMenu')">
        <span /><span /><span />
      </button>
      <div class="xs-topbar-logo">
        <img class="logo-icon" src="@/assets/img/logo.png" alt="" />
        <img class="logo-text" src="@/assets/img/whereToKnow_black.png" alt="Where to know" />
      </div>
      <!-- 侧边栏在手机宽度下隐藏，语言切换放到顶栏右侧（桌面端在每页标题行，见 CurrentDate.vue） -->
      <LanguageSwitch compact class="xs-topbar-lang" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import LanguageSwitch from '@/components/common/LanguageSwitch.vue';

export default {
  name: 'Navbar',
  components: { LanguageSwitch },
  data() {
    return { isXs: false };
  },
  mounted() {
    this.checkXs();
    window.addEventListener('resize', this.checkXs);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkXs);
  },
  methods: {
    ...mapMutations('hotel', ['SET_MOBILE_SIDEBAR_OPEN']),
    checkXs() { this.isXs = window.innerWidth < 1024; },
    openSidebar() { this.SET_MOBILE_SIDEBAR_OPEN(true); },
  },
};
</script>

<style lang="scss" scoped>
.xs-topbar-wrap {
  // no visual style — invisible when isXs=false
}

/* <1024: reserve the fixed bar's height so page content starts below it
   (the bar itself is position:fixed and therefore out of normal flow). */
@media (max-width: 1023px) {
  .xs-topbar-wrap {
    height: 56px;
  }
}

.xs-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #E8E4DC;
  /* Pinned to the viewport top — the whole bar stays put while the page
     scrolls. (sticky failed here: its wrapper is only 56px tall, so the
     sticky box had no room to stick and scrolled away immediately.) */
  position: fixed;
  top: 0;
  left: 0;
  // right: 0;
  /* Above in-page sticky filter bars (capped at 1010) so the top-bar stays
     visible while scrolling. Below the drawer (1050), its backdrop (1040)
     and the global export bar (2100). */
  z-index: 1011;
  width: 100vw;
  box-sizing: border-box;
}

.xs-hamburger {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  flex-shrink: 0;

  span {
    display: block;
    width: 18px;
    height: 1.5px;
    background: #232323;
    border-radius: 2px;
  }
}

/* 绝对居中：右侧语言按钮比左边汉堡宽，不能再靠两端等宽来居中 */
.xs-topbar-logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;

  .logo-icon {
    width: 28px;
    height: auto;
  }

  .logo-text {
    height: 14px;
    width: auto;
  }
}

.xs-topbar-lang {
  flex-shrink: 0;
}

// Phase 2 (Tablet 768–1023px): touch target needs >=44px.
@media (min-width: 600px) and (max-width: 1023px) {
  .xs-hamburger {
    width: 44px;
  }
  .xs-hamburger {
    height: 44px;
  }
}
</style>
